import { Component, OnInit, OnDestroy } from '@angular/core';
import { ConfigurationService, RiportMappaConfiguration } from '../../configuration/configuration.service';
import { ActivatedRoute, Params } from '@angular/router';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-report',
  templateUrl: './report.component.pug',
  styleUrls: ['./report.component.sass']
})
export class ReportComponent implements OnInit, OnDestroy {
  public riportmappa: RiportMappaConfiguration;
  public catalogFolder: any;
  public catalogItems: any;
  public riport: any;
  public riporturl: string;
  public reportloading: boolean;

  constructor(
    private configurationService: ConfigurationService,
    private authService: AuthService,
    private route: ActivatedRoute
  ) {
  }

  ngOnInit() {
    this.route.queryParams.forEach(async (params: Params) => {
      this.riportmappa = this.configurationService.riportModulConfiguration.riportmappak.find(m => m.felirat == params['mappa']);

      const ci = await this.authService.get<any>(this.riportmappa.url);

      const catalogItems = [];
      const folder = ci.value.find(f => f.Path == this.riportmappa.path);
      const folderId = folder ? folder.Id : undefined;
      if (folderId) {
        ci.value.filter(item => item.ParentFolderId == folderId && item.Type == "Report" && !item.Hidden).forEach(item => { 
          item.Description = item.Description || "";
          catalogItems.push(item); 
        });
      }
      this.catalogFolder = folder;
      this.catalogItems = catalogItems;
    });
  }

  ngOnDestroy(): void {
  }

  openreport(riport): void {
    this.reportloading = true;
    setTimeout(() => { this.reportloading = false; }, 3500);

    this.riport = riport;
    this.riporturl = this.riportmappa.viewer + '?' + riport.Path + '&rs:Command=Render&rs:Embed=true';
  }

  closereport(): void {
    this.reportloading = false;
    this.riporturl = undefined;
    this.riport = undefined;
  }

  reportloaded(): void {
    this.reportloading = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/report/report.component.ts